module.exports = __webpack_public_path__ + "static/img/MW.68f1d0d1.svg";